// Pages de compte (connexion, inscription) à la charte de l'observatoire — audit des anciennes
// chartes du 11/10, vague 2d. Rien de neuf : ce sont les jetons de `.obs2-jetons` (obs/obs.css)
// appliqués aux formes d'un formulaire. Marine plein pour l'action, bordure seule pour la carte
// (rayon 12 px, sans ombre), rayon 8 px pour champs et boutons, comme `.obs2-btn`.
// La page qui les emploie importe `obs/obs.css` et pose `obs2-jetons` sur son conteneur.
import '@fontsource/ibm-plex-serif/600.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '../obs/obs.css'

/** Fond de page : `landing` porte la paire Plex (titres serif, texte sans). */
export const FOND_COMPTE = 'obs2-jetons landing min-h-screen bg-(--c-bg) text-(--c-text) flex flex-col items-center justify-center px-4 py-10'
export const CARTE_COMPTE = 'bg-white rounded-(--radius) border border-(--c-border) p-6 sm:p-8'
export const LIBELLE = 'block text-sm font-medium text-(--c-text) mb-1.5'
export const CHAMP = 'w-full px-3.5 py-2.5 rounded-(--radius-sm) border border-(--c-border) bg-white text-(--c-text) placeholder:text-(--c-muted) focus:border-(--c-brand) focus:ring-2 focus:ring-(--c-brand)/15 outline-none transition'
export const BOUTON_PRINCIPAL = 'w-full bg-(--c-brand) text-white py-2.5 rounded-(--radius-sm) text-sm font-semibold hover:opacity-90 transition disabled:opacity-50'
export const LIEN = 'text-sm text-(--c-brand) underline underline-offset-2 hover:opacity-80'
export const LIEN_DISCRET = 'text-sm text-(--c-muted) hover:text-(--c-brand)'
